import './styles.scss'

export type HotOrCold = 'HOT' | 'COLD'

export type HotColdNumberProps = {
  hotOrCold: HotOrCold
  selectedNumber: number
  frequency: number
  loading: boolean
}

const ROOT_CLASS = `hot-cold-number`

export const HotColdNumber = (props: HotColdNumberProps) => {
  const percent = Math.floor(props.frequency * 100)
  return (
    <div
      className={ROOT_CLASS}
      aria-label={`${props.hotOrCold} Numbers Result. Number: ${props.selectedNumber}, Times Selected: ${percent}%`}>
      <div
        className={`${ROOT_CLASS}__selected-number ${props.hotOrCold}`}
        data-loading={props.loading ? 'loading' : ''}>
        <p>{props.selectedNumber}</p>
      </div>
      <div className={`${ROOT_CLASS}__frequency`} data-loading={props.loading ? 'loading' : ''}>
        <p>{percent}%</p>
      </div>
    </div>
  )
}
